import { render, staticRenderFns } from "./ResourceArea.vue?vue&type=template&id=0d48e98c&scoped=true&"
import script from "./ResourceArea.vue?vue&type=script&lang=js&"
export * from "./ResourceArea.vue?vue&type=script&lang=js&"
import style0 from "./ResourceArea.vue?vue&type=style&index=0&id=0d48e98c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48e98c",
  null
  
)

export default component.exports